import { createFileRoute, redirect } from '@tanstack/react-router'

// Legacy redirect — parent route handles redirect to /platform
export const Route = createFileRoute('/dashboard/')({
  beforeLoad: async () => {
    throw redirect({ to: '/platform' })
  },
  component: () => null,
})
